export default __webpack_public_path__ + "static/10.01-59dc46bd5fb58e1859b70ba3a9a4bc49.png";